import LoopIcon from '@mui/icons-material/Loop';
import EventIcon from '@mui/icons-material/Event';
import { CustomConfirmDialog } from '../../../components/CustomConfirmDialog';

export const RenewalChoiceDialog = (props: {
  open: boolean;
  onClose: () => void;
  onRenewNow: () => void;
  onPlanRenewal: () => void;
  dialogTitle?: string;
  planRenewalTitle?: string;
  planRenewalSubTitle?: string;
}) => (
  <CustomConfirmDialog
    open={props.open}
    handleClose={props.onClose}
    dialogTitle={props.dialogTitle ?? 'resources.renewal.text.choice_dialog_title'}
    dialogSubTitle="resources.renewal.text.choice_dialog_subtitle"
    icon1={{
      title: 'resources.renewal.text.renew_now',
      subTitle: 'resources.renewal.text.renew_now_subtitle',
      action: props.onRenewNow,
      icon: <LoopIcon />,
    }}
    icon2={{
      title: props.planRenewalTitle ?? 'resources.renewal.text.plan_renewal',
      subTitle: props.planRenewalSubTitle ?? 'resources.renewal.text.plan_renewal_subtitle',
      action: props.onPlanRenewal,
      icon: <EventIcon />,
    }}
  />
);
